'use client';
import { useTrials } from '@/context/trials-context';
import styles from './trial-per-page.module.css';
import { useProperties } from '@/context/properties-context';

export default function TrialPerPage() {
	const { properties, updateProperty } = useProperties();
	const { isLoading, trialsCount } = useTrials();

	if (isLoading || trialsCount === 0) return null;

	return (
		<div className={styles['trials-per-page']}>
			<label htmlFor='trials-per-page'>trials per page</label>
			<select
				disabled={isLoading}
				id='trials-per-page'
				name='trials-per-page'
				value={properties.trialsPerPage}
				onChange={(e) => updateProperty('trialsPerPage', +e.target.value)}
			>
				<option value='10'>10</option>
				<option value='25'>25</option>
				<option value='50'>50</option>
				<option value='100'>100</option>
			</select>
		</div>
	);
}
